import React, { useState } from "react";

import { SolutionsFrame } from "components/solutions/SolutionsFrame";
import { BlockStandard } from "components/admin/BlockStandard";
import {
  Checkbox,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useGreenEnergyContext } from "contexts/GreenEnergyContext";
import { EnergyGroups } from "api/onboardingTypes";
import { useSetError, useErrorInfo } from "contexts/ErrorContext";
import { CustomCodes } from "contexts/ErrorContextData";

const FRAME_DATA = {
  title: "Buscar melhores soluções",
  buttonText: "Continuar",
  nextScreen: "green-energy-status",
  skipTo: "green-energy-status",
  imgSrc: "/static/img/solutions/tension.png",
  h2Subtitle: "Está em baixa, média ou alta tensão?",
};

const TENSION_DATA: Array<{ value: EnergyGroups; text: string }> = [
  {
    value: "groupB",
    text: "Baixa tensão (Grupo B)",
  },
  {
    value: "groupA",
    text: "Média/Alta tensão (Grupo A)",
  },
  {
    value: "idk",
    text: "Não sei",
  },
];

export const BuildingTension = ({ history }) => {
  const [tension, setTension] = useState<EnergyGroups>();
  const { setEnergyGroup } = useGreenEnergyContext();
  const setGlobalError = useSetError();
  const errorInfo = useErrorInfo();
  const hasFormError = errorInfo?.code === CustomCodes.INCOMPLETE_FORM;

  const handleSubmit = () => {
    if (tension) {
      setEnergyGroup(tension);
      history.push(FRAME_DATA.nextScreen);
    } else {
      setGlobalError(CustomCodes.INCOMPLETE_FORM);
    }
  };

  return (
    <SolutionsFrame {...FRAME_DATA} onButtonClick={handleSubmit}>
      <BlockStandard hideDivider>
        <List>
          {TENSION_DATA.map(({ value, text }) => (
            <ListItem
              disablePadding
              key={value}
              sx={{
                border: `1px solid ${hasFormError && !tension ? "red" : "#595959"}`,
                borderRadius: "12px",
                mb: 2,
              }}
            >
              <ListItemButton onClick={() => setTension(value)}>
                <ListItemIcon>
                  <Checkbox
                    sx={{ color: "#595959" }}
                    color="success"
                    edge="start"
                    checked={tension === value}
                  />
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </BlockStandard>
    </SolutionsFrame>
  );
};
